'use client';

import { useAsync } from 'react-use';

import { Video } from '@/ui/Video/Video';

import { fetchVideoById } from './lib';

interface Props {
    id: number;
}

export function RenderVideo({ id }: Props) {
    const { value: video } = useAsync(() => fetchVideoById(id), [id]);

    if (video) {
        return <Video video={video} />;
    }

    return null;
}
